import { getValuesForSession } from 'store/actions/sessionActions';
import store from 'store/configure';
import { isNotBlank, isNotEmptyObject, isBlank } from './StringUtils';
import { LOGOUT_REDIRECT_URI, SYSTEM_ADMIN } from '../../../constants/Constants';
import authenticationManager from '../../../container/AuthenticationManager';
import axios from 'axios';
import automationAuthenticationManager from '../../../container/AutomationAuthenticationManager';
import get from 'lodash/get';

export const updateUserActivity = (activity) => {
    let tempConfig = isNotBlank(sessionStorage.getItem('identity_provider'))
        ? automationAuthenticationManager
        : authenticationManager;
    const url = `https://${window?.config?.API_URL}/iam/v2/users/activity`;
    const idToken = JSON.parse(
        sessionStorage.getItem(
            `oidc.user:${tempConfig.settings.authority}:${tempConfig.settings.client_id}`
        )
    ).id_token;
    return axios
        .create({
            headers: {
                Authorization: `Bearer ${idToken}`
            }
        })
        .post(url, { activityType: activity });
};

export const getFallBackAccessToken = () => {
    let tempConfig = isNotBlank(sessionStorage.getItem('identity_provider'))
        ? automationAuthenticationManager
        : authenticationManager;
    const idToken = JSON.parse(
        sessionStorage.getItem(
            `oidc.user:${tempConfig.settings.authority}:${tempConfig.settings.client_id}`
        )
    ).id_token;
    const access_token = sessionStorage.getItem('access_token');
    if (isBlank(access_token)) {
        sessionStorage.setItem('access_token', idToken);
        return idToken;
    }
    return access_token;
};
export const transformPermission = (permissionsData) => {
    let displayData = {};
    if (permissionsData !== undefined && permissionsData !== null && permissionsData.length !== 0) {
        permissionsData.forEach((feature) => {
            const resourceName = feature.name || '';
            const filteredFeatures = permissionsData.filter((pd) => pd.name === resourceName) || [];
            let data = [];

            filteredFeatures.forEach(({ apiEndpoints = [] }) => {
                let permission = {};

                apiEndpoints.forEach(({ internalRequestPath = '', enabled = false }) => {
                    if (internalRequestPath.includes('POST')) {
                        permission['write'] = enabled;
                    }
                    if (internalRequestPath.includes('GET')) {
                        permission['read'] = enabled;
                    }
                    if (internalRequestPath.includes('DELETE')) {
                        permission['delete'] = enabled;
                    }
                });

                data.push({ permission, feature_name: resourceName });
            });
            displayData[resourceName] = [...data];
        });
    }
    return displayData;
};

export const setUserSession = (userInfo, flag) => {
    if (isNotEmptyObject(userInfo)) {
        store.dispatch(getValuesForSession(userInfo, flag));
    }
};

export const getURLAccountId = () => {
    const urlAccountId = new URLSearchParams(window.location.search).get('accountId');
    const storageAccountId = sessionStorage.getItem('urlAccountId');
    let accountId = '';
    if (isNotBlank(urlAccountId)) {
        accountId = urlAccountId;
    } else if (isNotBlank(storageAccountId)) {
        accountId = storageAccountId;
    }
    return accountId;
};

export const signOut = () => {
    sessionStorage.removeItem('urlAccountId');
    let tempConfig = isNotBlank(sessionStorage.getItem('identity_provider'))
        ? automationAuthenticationManager
        : authenticationManager;
    updateUserActivity('LOGOUT');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('identity_provider');
    tempConfig.signoutRedirect();
};

export const generateCookieDomain = () => {
    if (LOGOUT_REDIRECT_URI.includes('dev')) {
        return '.dev.trimble-transportation.com';
    } else if (LOGOUT_REDIRECT_URI.includes('stg')) {
        return '.stg.trimble-transportation.com';
    }
    return '.trimble-transportation.com';
};

export const generateUserRoleEnabledFlag = () => {
    return window.config.IS_ROLE_USER_ENABLED === 'true';
};

export const getAccountId = (getState) => {
    const { sessionValue } = getState().session ?? {};
    return sessionValue.userRole === SYSTEM_ADMIN
        ? get(getState(), 'accounts.selectedAccount.objectId')
        : sessionValue.accountId;
};

export const getSelectedAccountUuid = (getState) => {
    const accountId = getState().session.sessionValue.accountUuid;
    return get(getState(), 'accounts.selectedAccount.id', accountId);
};
